function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const activeAnnotationButton = $attr(`active-annotation`);;
    const isPreview = $attr(`type`) === $helpers.AnnotationViewType.PREVIEW;;
    const {
      activeAnnotationGroup,
      numAnnotations
    } = $helpers.getActiveAnnotationGroup();;
    const canWriteAnnotations = $attr(`can-write-annotations`);;
    const editingAnnotation = $attr(`editing-annotation`);;
    const deletingAnnotation = $attr(`deleting-annotation`);;
    const annotationDescriptionDraft = $attr(`annotation-description-draft`);;
    return {
      value: (h("div", {
        "class": {
          'annotations-viewer-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((activeAnnotationButton) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'annotations-viewer-is-preview': isPreview
            }, {
              'annotations-viewer-header': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'annotations-viewer-header-date': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(activeAnnotationButton.formattedDate);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'annotations-viewer-header-count': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(numAnnotations === 1 ? `${numAnnotations} Annotation` : `${numAnnotations} Annotations`);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'annotations-viewer-annotations-list': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (activeAnnotationGroup);
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, annotation, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    const isEditingThisAnnotation = editingAnnotation && editingAnnotation.id === annotation.id;
                    const isDeletingThisAnnotation = deletingAnnotation && deletingAnnotation.id === annotation.id; /*  have to coerce the `isEditingThisAnnotation` variable into a bool to ensure the class gets taken off on state change */
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": Object.assign({}, {
                        'annotations-viewer-editing': !!isEditingThisAnnotation,
                        'annotations-viewer-is-preview': isPreview,
                      }, {
                        'annotations-viewer-annotation-row': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((!isEditingThisAnnotation) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'annotations-viewer-annotation-icon': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-user-icon", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              name: annotation.user && `${annotation.user.first_name} ${annotation.user.last_name}`,
                              id: annotation.user && annotation.user.id,
                              'disable-tooltip': true,
                              size: `medium`,
                            }),
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'annotations-viewer-annotation-content': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'annotations-viewer-annotation-header': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'annotations-viewer-annotation-meta': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((annotation.user) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'annotations-viewer-annotation-user-label': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(`${annotation.user.first_name} ${annotation.user.last_name && annotation.user.last_name[0]}`);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'annotations-viewer-annotation-date-label': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat($helpers.formatDate(annotation.highchartsDate));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat((canWriteAnnotations && !isEditingThisAnnotation && !isDeletingThisAnnotation) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'annotations-viewer-annotation-actions': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  icon: `edit`,
                                  theme: `tertiary`
                                }),
                                "on": {
                                  click: () => $helpers.edit(annotation)
                                },
                                "class": {
                                  'annotations-viewer-annotation-edit-button': true
                                },
                              }));
                              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  icon: `trashcan`,
                                  theme: `tertiary`,
                                  type: `destructive`
                                }),
                                "on": {
                                  click: () => $helpers.delete(annotation)
                                },
                                "class": {
                                  'annotations-viewer-annotation-delete-button': true
                                },
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat((isEditingThisAnnotation) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'annotations-viewer-annotation-edit-mode': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("textarea", {
                              "on": {
                                input: $helpers.handleDescriptionChanged
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(annotation.description);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'annotations-viewer-annotation-edit-actions': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  theme: `tertiary`
                                }),
                                "on": {
                                  click: $helpers.editCanceled
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("Cancel");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  theme: `primary`,
                                  disabled: !annotationDescriptionDraft
                                }),
                                "on": {
                                  click: $helpers.save
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("Save");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": Object.assign({}, {
                              'annotations-viewer-is-preview': isPreview
                            }, {
                              'annotations-viewer-annotation-description': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(annotation.description);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat((isDeletingThisAnnotation) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'annotations-viewer-confirm-delete-container': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'annotations-viewer-confirm-delete-buttons': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-button", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                theme: `secondary`
                              }),
                              "on": {
                                click: $helpers.deleteCanceled
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("Cancel");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(h("mp-button", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                theme: `primary`,
                                type: `destructive`
                              }),
                              "on": {
                                click: $helpers.deleteConfirmed
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("Delete");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var annotation = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        const isEditingThisAnnotation = editingAnnotation && editingAnnotation.id === annotation.id;
                        const isDeletingThisAnnotation = deletingAnnotation && deletingAnnotation.id === annotation.id; /*  have to coerce the `isEditingThisAnnotation` variable into a bool to ensure the class gets taken off on state change */
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": Object.assign({}, {
                            'annotations-viewer-editing': !!isEditingThisAnnotation,
                            'annotations-viewer-is-preview': isPreview,
                          }, {
                            'annotations-viewer-annotation-row': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((!isEditingThisAnnotation) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'annotations-viewer-annotation-icon': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-user-icon", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  name: annotation.user && `${annotation.user.first_name} ${annotation.user.last_name}`,
                                  id: annotation.user && annotation.user.id,
                                  'disable-tooltip': true,
                                  size: `medium`,
                                }),
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'annotations-viewer-annotation-content': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'annotations-viewer-annotation-header': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'annotations-viewer-annotation-meta': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((annotation.user) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'annotations-viewer-annotation-user-label': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(`${annotation.user.first_name} ${annotation.user.last_name && annotation.user.last_name[0]}`);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'annotations-viewer-annotation-date-label': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat($helpers.formatDate(annotation.highchartsDate));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              __jade_nodes = __jade_nodes.concat((canWriteAnnotations && !isEditingThisAnnotation && !isDeletingThisAnnotation) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'annotations-viewer-annotation-actions': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      icon: `edit`,
                                      theme: `tertiary`
                                    }),
                                    "on": {
                                      click: () => $helpers.edit(annotation)
                                    },
                                    "class": {
                                      'annotations-viewer-annotation-edit-button': true
                                    },
                                  }));
                                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      icon: `trashcan`,
                                      theme: `tertiary`,
                                      type: `destructive`
                                    }),
                                    "on": {
                                      click: () => $helpers.delete(annotation)
                                    },
                                    "class": {
                                      'annotations-viewer-annotation-delete-button': true
                                    },
                                  }));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat((isEditingThisAnnotation) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'annotations-viewer-annotation-edit-mode': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("textarea", {
                                  "on": {
                                    input: $helpers.handleDescriptionChanged
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(annotation.description);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'annotations-viewer-annotation-edit-actions': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      theme: `tertiary`
                                    }),
                                    "on": {
                                      click: $helpers.editCanceled
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat("Cancel");;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));
                                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      theme: `primary`,
                                      disabled: !annotationDescriptionDraft
                                    }),
                                    "on": {
                                      click: $helpers.save
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat("Save");;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": Object.assign({}, {
                                  'annotations-viewer-is-preview': isPreview
                                }, {
                                  'annotations-viewer-annotation-description': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(annotation.description);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat((isDeletingThisAnnotation) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'annotations-viewer-confirm-delete-container': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'annotations-viewer-confirm-delete-buttons': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    theme: `secondary`
                                  }),
                                  "on": {
                                    click: $helpers.deleteCanceled
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat("Cancel");;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                                  "attrs": __vjadeStringifyAttrsIfObj({
                                    theme: `primary`,
                                    type: `destructive`
                                  }),
                                  "on": {
                                    click: $helpers.deleteConfirmed
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat("Delete");;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": Object.assign({}, {
              'annotations-viewer-is-preview': isPreview
            }, {
              'annotations-viewer-footer': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((isPreview) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((numAnnotations > 2) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("+ " + (numAnnotations - 2) + " more...");;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "on": {
                  click: $helpers.createAnnotation
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Add Annotation");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;